<app-slide-in-right-modal
  modalTitle="Import Benchmark"
  iconImageSrc="assets/images/svgs/document--outline.svg"
  [slideOpen]="true"
  [showBackLink]="false"
  returnPath=""
>
  <div class="page__container flex flex-col pb-8">
    <p class="cta__text text-sm text-mango-gray74">
      Upload benchmark data file or enter daily benchmark manually.
    </p>

    <form class="flex flex-col gap-5 px-0 pt-5" [formGroup]="benchmarkImportForm">
      <app-tabs
        [tabs]="tabs"
        [selectedTab]="selectedTab"
        [initialSelectedTab]="0"
        (tabChange)="onTabChange($event)"
      ></app-tabs>

      <ng-template #dataFileTemplate>
        <div class="mt-5">
          <app-input-label labelFor="benchmark-file" labelClass="label--bottom-margin" [isRequired]="true">
            Upload benchmark data file
          </app-input-label>

          <input
            id="benchmark-file"
            type="file"
            class="hidden"
            accept=".csv,.xlsx,.xls"
            (change)="onFileSelected($event)"
          />

          <label
            for="benchmark-file"
            class="flex w-full cursor-pointer items-center rounded-xl border border-dashed border-gray-300 bg-gray-50 px-4 py-3 text-sm text-gray-700"
          >
            <span>{{ selectedFileName || 'Choose file (CSV, XLSX, XLS)' }}</span>
          </label>
        </div>
      </ng-template>

      <ng-template #manualUploadTemplate>
        <div class="mt-5">
          <app-input-label labelFor="date" labelClass="label--bottom-margin" [isRequired]="true">
            Date
          </app-input-label>
          <input
            id="date"
            type="date"
            formControlName="date"
            class="block w-full rounded-lg border-0 pl-2 text-base text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-mango sm:leading-6"
          />
        </div>

        <div class="mt-5">
          <app-input-label labelFor="rate" labelClass="label--bottom-margin" [isRequired]="true">
            Rate
          </app-input-label>
          <input
            id="rate"
            type="number"
            step="0.0001"
            min="0"
            formControlName="rate"
            placeholder="Enter benchmark rate"
            class="block w-full rounded-lg border-0 pl-2 text-base text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-mango sm:leading-6"
          />
        </div>
      </ng-template>

  
      <div class="col-start-3 justify-self-end">
        <button
          (click)="saveBenchmark()"
          [disabled]="benchmarkImportForm.invalid || (isLoading$ | async)!"
          [loading]="(isLoading$ | async)!"
          class="w-full justify-center xl:col-start-2 xl:w-fit xl:justify-self-end"
          mango-button
        >
        @if (isLoading$ | async) {
          <span>Saving benchmark...</span>
        } @else {
          <span>Save Benchmark</span>
        }
        </button>
      </div>
    </form>
  </div>
</app-slide-in-right-modal>
